
function DateToString( date: Date ): string {
  return date.toLocaleString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'})
}

export const DAYS_IN_CALENDAR = 90;

export default DateToString;